/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonApiLog,
    JsonApiLogFromJSON,
    JsonApiLogFromJSONTyped,
    JsonApiLogToJSON,
} from './JsonApiLog';

/**
 * 
 * @export
 * @interface ApiResultOfJsonApiLog
 */
export interface ApiResultOfJsonApiLog {
    /**
     * 
     * @type {JsonApiLog}
     * @memberof ApiResultOfJsonApiLog
     */
    data?: JsonApiLog;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonApiLog
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonApiLog
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonApiLog
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonApiLog
     */
    result?: ApiResultOfJsonApiLogResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonApiLogResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonApiLogFromJSON(json: any): ApiResultOfJsonApiLog {
    return ApiResultOfJsonApiLogFromJSONTyped(json, false);
}

export function ApiResultOfJsonApiLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonApiLog {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonApiLogFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonApiLogToJSON(value?: ApiResultOfJsonApiLog | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonApiLogToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

